import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

import { FlavorType } from 'src/app/products/interfaces/models';

import { JuiceProperties } from '@app/api/models';
import { SubformBaseWithSugarContentPropertiesComponent } from '@products/components/forms/subform-base-with-sugar-content-properties/subform-base-with-sugar-content-properties.component';

@Component({
  selector: 'app-juice-properties-subform',
  styleUrls: ['./juice-properties-subform.component.scss'],
  templateUrl: './juice-properties-subform.component.html',
})
export class JuicePropertiesSubformComponent extends SubformBaseWithSugarContentPropertiesComponent {
  override alcoholic = false;
  DICT_PATH = 'PRODUCTS.JUICE_PROPERTIES';

  flavorType = FlavorType;

  static buildForm(fb: FormBuilder, data?: JuiceProperties) {
    return fb.group({
      flavorTypes: [data?.flavorTypes, Validators.required],
      brixValue: [data?.brixValue, Validators.required],
      containsAtLeast25PercentFruitsOrVegetables: [
        data?.containsAtLeast25PercentFruitsOrVegetables ?? false,
      ],
      containsAtLeast50PercentMilkBasedMaterial: [
        data?.containsAtLeast50PercentMilkBasedMaterial ?? false,
      ],
      frozen: [data?.frozen ?? false],
      netValueEur: [data?.netValueEur, Validators.required],

      // build sugar content properties
      ...SubformBaseWithSugarContentPropertiesComponent.buildFields(data),
    });
  }
}
